import React from 'react';
import PropTypes from 'prop-types';
import { TemporaryDrawer, useDrawer } from 'swipeclock-frontend';
import { webClockContextKeys } from '../constants/webClockContextKeys';
import OfflinePunchDrawerContent from './OfflinePunchDrawerContent';

export default function OfflinePunchDrawerManager({ id }) {
  const { open: isOpen, closeDrawer } = useDrawer(
    webClockContextKeys.OFFLINE_PUNCHES
  );

  const testingID = `${id}__OfflinePunchDrawer`;

  return (
    <TemporaryDrawer
      id={testingID}
      onClose={closeDrawer}
      open={isOpen}
      ModalProps={{
        keepMounted: false,
      }}
    >
      <OfflinePunchDrawerContent id={testingID} />
    </TemporaryDrawer>
  );
}

OfflinePunchDrawerManager.propTypes = {
  id: PropTypes.string.isRequired,
};
